// src/components/ui/forms/ConfigToggleField/ConfigToggleFieldShadcn.jsx
import React from 'react';

// shadcn components
import { Switch } from '../../switch';
import { Label } from '../../label';

import { cn } from '../../../../utils/cn';

const ConfigToggleFieldShadcn = ({
  label,
  description,
  value,
  onChange,
  disabled = false,
  className = ""
}) => {
  return (
    <div className={cn(
      "flex items-center justify-between p-4 rounded-xl",
      "bg-slate-700/30 border border-slate-600/50",
      "transition-all duration-300",
      disabled && "opacity-50 cursor-not-allowed",
      className
    )}>
      {/* Label and Description */}
      <div className="flex-1">
        <Label className="text-sm font-medium text-slate-200 block">
          {label}
        </Label>
        {description && (
          <p className="text-xs text-slate-400 mt-1">{description}</p>
        )}
      </div>

      {/* Toggle Switch */}
      <Switch
        checked={value || false}
        onCheckedChange={onChange}
        disabled={disabled}
        className={cn(
          "relative inline-flex items-center",
          value
            ? "bg-gradient-to-r from-blue-500 to-blue-400"
            : "bg-slate-600"
        )}
      />
    </div>
  );
};

export default ConfigToggleFieldShadcn;